export default {
    // 中
    zhCN: {
        fill_in_at_least_one_query_condition: '至少填写一个查询条件',
        reporting_organization_name: '上报组织名称',
        full_query: '全量查询',
        query_time: '查询时间',
        organization_code: '组织CODE',
        organization_name: '组织名称',
        country: '国家',
        number_of_cases: '案例总数',
        number_of_qualified_cases: '合格案例数量',
        percentage_of_qualified_cases: '合格案例百分比',
        number_of_unqualified_cases: '不合格案例数量',
        percentage_of_unqualified_cases: '不合格案例百分比',
    },
    // 英
    enUS: {
        fill_in_at_least_one_query_condition: 'Fill in at least one query condition',
        reporting_organization_name: 'Reporting organization name',
        full_query: 'Full query',
        query_time: 'Query time',
        organization_code: 'Organization code',
        organization_name: 'Organization name',
        country: 'Country',
        number_of_cases: 'Number of cases',
        number_of_qualified_cases: 'Number of qualified cases',
        percentage_of_qualified_cases: 'Percentage of Qualified Cases',
        number_of_unqualified_cases: 'Number of unqualified cases',
        percentage_of_unqualified_cases: 'Percentage of unqualified cases',
    },
    // 德
    deDE: {
        fill_in_at_least_one_query_condition: 'Füllen Sie mindestens eine Abfragebedingung aus',
        reporting_organization_name: 'Name der meldenden Organisation',
        full_query: 'Vollständige Abfrage',
        query_time: 'Abfragezeit',
        organization_code: 'Organisationscode',
        organization_name: 'Organisationsname',
        country: 'Land',
        number_of_cases: 'Gesamtzahl der Fälle',
        number_of_qualified_cases: 'Anzahl qualifizierter Fälle',
        percentage_of_qualified_cases: 'Prozentsatz qualifizierter Fälle',
        number_of_unqualified_cases: 'Anzahl der nicht konformen Fälle',
        percentage_of_unqualified_cases: 'Prozentsatz der nicht konformen Fälle',
    },
    // 法
    frFR: {
        fill_in_at_least_one_query_condition: 'Remplissez au moins une condition de demande',
        reporting_organization_name: 'Nom de l\'organisation de rapport',
        full_query: 'Requête complète',
        query_time: 'Temps de requête',
        organization_code: 'Code organisation',
        organization_name: 'Nom organisation',
        country: 'Pays',
        number_of_cases: 'Total cas',
        number_of_qualified_cases: 'Nombre de cas admissibles',
        percentage_of_qualified_cases: 'Pourcentage de cas admissibles',
        number_of_unqualified_cases: 'Nombre de cas de non - conformité',
        percentage_of_unqualified_cases: 'Pourcentage de cas de non - conformité',
    },
    // 意大利
    itIT: {
        fill_in_at_least_one_query_condition: 'Compilare almeno una condizione di query',
        reporting_organization_name: 'Nome Organizzazione Segnalante',
        full_query: 'Query Completa',
        query_time: 'Tempo di Query',
        organization_code: 'Codice Organizzazione',
        organization_name: 'Nome Organizzazione',
        country: 'Paese',
        number_of_cases: 'Numero totale di casi',
        number_of_qualified_cases: 'Numero di casi ammissibili',
        percentage_of_qualified_cases: 'Percentuale di casi qualificati',
        number_of_unqualified_cases: 'Numero di casi non conformi',
        percentage_of_unqualified_cases: 'Percentuale di casi non conformi',
    },
    // 荷兰
    nlNL: {
        fill_in_at_least_one_query_condition: 'Vul ten minste één query voorwaarde in',
        reporting_organization_name: 'Rapporterende organisatienaam',
        full_query: 'Volledige query',
        query_time: 'Query time',
        organization_code: 'Organisatie code',
        organization_name: 'Organisatie naam',
        country: 'Land',
        number_of_cases: 'Totaal aantal gevallen',
        number_of_qualified_cases: 'Aantal gekwalificeerde gevallen',
        percentage_of_qualified_cases: 'Percentage gekwalificeerde zaken',
        number_of_unqualified_cases: 'Aantal niet-conforme gevallen',
        percentage_of_unqualified_cases: 'Percentage niet-conforme gevallen',
    },
    // 越南
    viVN: {
        fill_in_at_least_one_query_condition: 'Ít nhất điền một điều kiện tìm kiếm',
        reporting_organization_name: 'Tên tổ chức báo cáo',
        full_query: 'Tra cứu toàn bộ',
        query_time: 'Thời gian truy vấn',
        organization_code: 'Mã tổ chức',
        organization_name: 'Tên tổ chức',
        country: 'Quốc gia',
        number_of_cases: 'Tổng số trường hợp',
        number_of_qualified_cases: 'Số lượng trường hợp đạt yêu cầu',
        percentage_of_qualified_cases: 'Phần trăm trường hợp đạt yêu cầu',
        number_of_unqualified_cases: 'Số lượng trường hợp không đạt yêu cầu',
        percentage_of_unqualified_cases: 'Phần trăm trường hợp không đạt yêu cầu',
    },
    // 西班牙
    esES: {
        fill_in_at_least_one_query_condition: 'Al menos complete un criterio de búsqueda',
        reporting_organization_name: 'Nombre de la organización de informes',
        full_query: 'Consulta completa',
        query_time: 'Tiempo de consulta',
        organization_code: 'Código de la organización',
        organization_name: 'Nombre de la organización',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_qualified_cases: 'Número de casos calificados como aptos',
        percentage_of_qualified_cases: 'Porcentaje de casos calificados como aptos',
        number_of_unqualified_cases: 'Número de casos calificados como no aptos',
        percentage_of_unqualified_cases: 'Porcentaje de casos calificados como no aptos',
    },
    // 葡萄牙
    ptBR: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização de relatório',
        full_query: 'Consulta completa',
        query_time: 'Tempo da consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_qualified_cases: 'Número de casos qualificados',
        percentage_of_qualified_cases: 'Porcentagem de casos qualificados',
        number_of_unqualified_cases: 'Número de casos não qualificados',
        percentage_of_unqualified_cases: 'Porcentagem de casos não qualificados',
    },
    // 波兰
    plPL: {
        fill_in_at_least_one_query_condition: 'Wypełnij co najmniej jeden warunek zapytania',
        reporting_organization_name: 'Nazwa organizacji raportującej',
        full_query: 'Pełne zapytanie',
        query_time: 'Data zapytania',
        organization_code: 'Kod organizacji',
        organization_name: 'Nazwa organizacji',
        country: 'Kraj',
        number_of_cases: 'Łączna liczba spraw',
        number_of_qualified_cases: 'Liczba spraw zakwalifikowanych',
        percentage_of_qualified_cases: 'Liczba spraw zakwalifikowanych (%)',
        number_of_unqualified_cases: 'Liczba spraw niezakwalifikowanych',
        percentage_of_unqualified_cases: 'Liczba spraw niezakwalifikowanych (%)',
    },
    // 土耳其语
    trTR: {
        fill_in_at_least_one_query_condition: 'En azından bir soru durumunu doldur',
        reporting_organization_name: 'Bildirim organizasyonu adı',
        full_query: 'Tam sorgulama',
        query_time: 'Sorgulama zamanı',
        organization_code: 'Organizasyon CODE',
        organization_name: 'Organizasyon adı',
        country: 'Ülke',
        number_of_cases: 'Toplam dosyalar',
        number_of_qualified_cases: 'Onaylanmış dosya sayısı',
        percentage_of_qualified_cases: 'Onaylanmış dosya sayısının yüzdesi',
        number_of_unqualified_cases: 'Onaylanmamış dosya sayısı',
        percentage_of_unqualified_cases: 'Onaylanmamış dosya sayısının yüzdesi',
    },
    // 捷克语
    csCZ: {
        fill_in_at_least_one_query_condition: 'Vyplňte alespoň jednu podmínku dotazu',
        reporting_organization_name: 'Název ohlašující společnosti',
        full_query: 'Úplný dotaz',
        query_time: 'Čas dotazu',
        organization_code: 'Kód společnosti',
        organization_name: 'Název společnosti',
        country: 'Země',
        number_of_cases: 'Počet případů',
        number_of_qualified_cases: 'Počet kvalifikovaných případů',
        percentage_of_qualified_cases: 'Procento kvalifikovaných případů',
        number_of_unqualified_cases: 'Počet nekvalifikovaných případů',
        percentage_of_unqualified_cases: 'Procento nekvalifikovaných případů',
    },
    // 匈牙利语
    huHU: {
        fill_in_at_least_one_query_condition: 'Töltsön ki legalább egy lekérdezési feltételt',
        reporting_organization_name: 'Jelentő szervezet neve',
        full_query: 'Teljes lekérdezés',
        query_time: 'Lekérdezési idő',
        organization_code: 'Szervezet kódja',
        organization_name: 'Szervezet neve',
        country: 'Ország',
        number_of_cases: 'Esetek száma',
        number_of_qualified_cases: 'Minősített esetek száma',
        percentage_of_qualified_cases: 'Minősített esetek százaléka',
        number_of_unqualified_cases: 'Nem minősített esetek száma',
        percentage_of_unqualified_cases: 'Nem minősített esetek százaléka',
    },
    // 俄罗斯语
    ruRU: {
        fill_in_at_least_one_query_condition: 'Заполните хотя бы одно условие запроса',
        reporting_organization_name: 'Название отчетной организации',
        full_query: 'Полный запрос',
        query_time: 'Время запроса',
        organization_code: 'Код организации',
        organization_name: 'Название организации',
        country: 'Страна',
        number_of_cases: 'Общее количество случаев',
        number_of_qualified_cases: 'Количество квалифицированных случаев',
        percentage_of_qualified_cases: 'Процент квалифицированных случаев',
        number_of_unqualified_cases: 'Количество неквалифицированных случаев',
        percentage_of_unqualified_cases: 'Процент неквалифицированных случаев',
    },
    // 沙特阿拉伯 (阿拉伯语)
    arSA: {
        fill_in_at_least_one_query_condition: 'يرجى إدخال شرط بحث واحد على الأقل',
        reporting_organization_name: 'اسم المنظمة المبلغة',
        full_query: 'استعلام كامل',
        query_time: 'وقت الاستعلام',
        organization_code: 'رمز المنظمة',
        organization_name: 'اسم المنظمة',
        country: 'الدولة',
        number_of_cases: 'إجمالي عدد الحالات',
        number_of_qualified_cases: 'عدد الحالات المؤهلة',
        percentage_of_qualified_cases: 'نسبة الحالات المؤهلة',
        number_of_unqualified_cases: 'عدد الحالات غير المؤهلة',
        percentage_of_unqualified_cases: 'نسبة الحالات غير المؤهلة',
    },
    // 保加利亚
    bgBG: {
        fill_in_at_least_one_query_condition: 'Моля, попълнете поне едно условие за търсене',
        reporting_organization_name: 'Име на докладващата организация',
        full_query: 'Пълен заявкa',
        query_time: 'Време на заявката',
        organization_code: 'Код на организацията',
        organization_name: 'Име на организацията',
        country: 'Държава',
        number_of_cases: 'Общ брой случаи',
        number_of_qualified_cases: 'Брой квалифицирани случаи',
        percentage_of_qualified_cases: 'Процент квалифицирани случаи',
        number_of_unqualified_cases: 'Брой неквалифицирани случаи',
        percentage_of_unqualified_cases: 'Процент неквалифицирани случаи',
    },
    // 丹麦语
    daDK: {
        fill_in_at_least_one_query_condition: 'Angiv mindst ét søgekriterie',
        reporting_organization_name: 'Rapporterende organisationsnavn',
        full_query: 'Fuld forespørgsel',
        query_time: 'Forespørgselstidspunkt',
        organization_code: 'Organisationskode',
        organization_name: 'Organisationsnavn',
        country: 'Land',
        number_of_cases: 'Samlet antal sager',
        number_of_qualified_cases: 'Antal kvalificerede sager',
        percentage_of_qualified_cases: 'Procentdel af kvalificerede sager',
        number_of_unqualified_cases: 'Antal ikke-kvalificerede sager',
        percentage_of_unqualified_cases: 'Procentdel af ikke-kvalificerede sager',
    },
    // 芬兰语
    fiFI: {
        fill_in_at_least_one_query_condition: 'Anna vähintään yksi hakuehto',
        reporting_organization_name: 'Ilmoittavan organisaation nimi',
        full_query: 'Koko tietojoukko',
        query_time: 'Hakuaika',
        organization_code: 'Organisaatiokoodi',
        organization_name: 'Organisaation nimi',
        country: 'Maa',
        number_of_cases: 'Tapauksien kokonaismäärä',
        number_of_qualified_cases: 'Hyväksyttyjen tapausten määrä',
        percentage_of_qualified_cases: 'Hyväksyttyjen tapausten prosenttiosuus',
        number_of_unqualified_cases: 'Hylättyjen tapausten määrä',
        percentage_of_unqualified_cases: 'Hylättyjen tapausten prosenttiosuus',
    },
    // 繁体中文（台湾）
    zhTW: {
        fill_in_at_least_one_query_condition: '至少填寫一個查詢條件',
        reporting_organization_name: '上報組織名稱',
        full_query: '全量查詢',
        query_time: '查詢時間',
        organization_code: '組織CODE',
        organization_name: '組織名稱',
        country: '國家',
        number_of_cases: '案例總數',
        number_of_qualified_cases: '合格案例數量',
        percentage_of_qualified_cases: '合格案例百分比',
        number_of_unqualified_cases: '不合格案例數量',
        percentage_of_unqualified_cases: '不合格案例百分比',
    },
    // 克罗地亚
    hrHR: {
        fill_in_at_least_one_query_condition: 'Unesite barem jedan uvjet pretraživanja',
        reporting_organization_name: 'Naziv prijavljujuće organizacije',
        full_query: 'Potpuno upit',
        query_time: 'Vrijeme upita',
        organization_code: 'Kôd organizacije',
        organization_name: 'Naziv organizacije',
        country: 'Država',
        number_of_cases: 'Ukupan broj slučajeva',
        number_of_qualified_cases: 'Broj kvalificiranih slučajeva',
        percentage_of_qualified_cases: 'Postotak kvalificiranih slučajeva',
        number_of_unqualified_cases: 'Broj nekvalificiranih slučajeva',
        percentage_of_unqualified_cases: 'Postotak nekvalificiranih slučajeva',
    },
    // 拉脱维亚
    lvLV: {
        fill_in_at_least_one_query_condition:
            'Lūdzu, aizpildiet vismaz vienu meklēšanas nosacījumu',
        reporting_organization_name: 'Ziņojošās organizācijas nosaukums',
        full_query: 'Pilns vaicājums',
        query_time: 'Vaicājuma laiks',
        organization_code: 'Organizācijas kods',
        organization_name: 'Organizācijas nosaukums',
        country: 'Valsts',
        number_of_cases: 'Gadījumu kopējais skaits',
        number_of_qualified_cases: 'Kvalificēto gadījumu skaits',
        percentage_of_qualified_cases: 'Kvalificēto gadījumu procents',
        number_of_unqualified_cases: 'Nekvalificēto gadījumu skaits',
        percentage_of_unqualified_cases: 'Nekvalificēto gadījumu procents',
    },
    // 立陶宛
    ltLT: {
        fill_in_at_least_one_query_condition: 'Įveskite bent vieną paieškos sąlygą',
        reporting_organization_name: 'Pranešančios organizacijos pavadinimas',
        full_query: 'Visų duomenų užklausa',
        query_time: 'Užklausos laikas',
        organization_code: 'Organizacijos kodas',
        organization_name: 'Organizacijos pavadinimas',
        country: 'Šalis',
        number_of_cases: 'Atvejų skaičius iš viso',
        number_of_qualified_cases: 'Kvalifikuotų atvejų skaičius',
        percentage_of_qualified_cases: 'Kvalifikuotų atvejų procentas',
        number_of_unqualified_cases: 'Nekvalifikuotų atvejų skaičius',
        percentage_of_unqualified_cases: 'Nekvalifikuotų atvejų procentas',
    },
    // 罗马尼亚
    roRO: {
        fill_in_at_least_one_query_condition: 'Completați cel puțin o condiție de căutare',
        reporting_organization_name: 'Numele organizației raportoare',
        full_query: 'Interogare completă',
        query_time: 'Timpul interogării',
        organization_code: 'Codul organizației',
        organization_name: 'Numele organizației',
        country: 'Țară',
        number_of_cases: 'Număr total de cazuri',
        number_of_qualified_cases: 'Numărul de cazuri calificate',
        percentage_of_qualified_cases: 'Procentul cazurilor calificate',
        number_of_unqualified_cases: 'Numărul de cazuri necalificate',
        percentage_of_unqualified_cases: 'Procentul cazurilor necalificate',
    },
    // 挪威博克马尔
    nbNO: {
        fill_in_at_least_one_query_condition: 'Fyll ut minst ett søkekriterium',
        reporting_organization_name: 'Rapporterende organisasjonsnavn',
        full_query: 'Full spørring',
        query_time: 'Spørringstidspunkt',
        organization_code: 'Organisasjonskode',
        organization_name: 'Organisasjonsnavn',
        country: 'Land',
        number_of_cases: 'Totalt antall saker',
        number_of_qualified_cases: 'Antall kvalifiserte saker',
        percentage_of_qualified_cases: 'Prosentandel kvalifiserte saker',
        number_of_unqualified_cases: 'Antall ukvalifiserte saker',
        percentage_of_unqualified_cases: 'Prosentandel ukvalifiserte saker',
    },
    // 葡萄牙语（巴西）
    ptBX: {
        fill_in_at_least_one_query_condition: 'Preencha pelo menos uma condição de consulta',
        reporting_organization_name: 'Nome da organização reportante',
        full_query: 'Consulta completa',
        query_time: 'Horário da consulta',
        organization_code: 'Código da organização',
        organization_name: 'Nome da organização',
        country: 'País',
        number_of_cases: 'Número total de casos',
        number_of_qualified_cases: 'Quantidade de casos qualificados',
        percentage_of_qualified_cases: 'Percentual de casos qualificados',
        number_of_unqualified_cases: 'Quantidade de casos não qualificados',
        percentage_of_unqualified_cases: 'Percentual de casos não qualificados',
    },
    // 瑞典语
    svSE: {
        fill_in_at_least_one_query_condition: 'Ange minst ett sökvillkor',
        reporting_organization_name: 'Rapporterande organisationsnamn',
        full_query: 'Fullständig förfrågan',
        query_time: 'Förfråganstidpunkt',
        organization_code: 'Organisationskod',
        organization_name: 'Organisationsnamn',
        country: 'Land',
        number_of_cases: 'Totalt antal fall',
        number_of_qualified_cases: 'Antal godkända ärenden',
        percentage_of_qualified_cases: 'Andel godkända ärenden (%)',
        number_of_unqualified_cases: 'Antal underkända ärenden',
        percentage_of_unqualified_cases: 'Andel underkända ärenden (%)',
    },
    // 斯洛伐克
    skSK: {
        fill_in_at_least_one_query_condition: 'Zadajte aspoň jednu podmienku vyhľadávania',
        reporting_organization_name: 'Názov nahlásenej organizácie',
        full_query: 'Kompletný dopyt',
        query_time: 'Čas dopytu',
        organization_code: 'Kód organizácie',
        organization_name: 'Názov organizácie',
        country: 'Krajina',
        number_of_cases: 'Celkový počet prípadov',
        number_of_qualified_cases: 'Počet kvalifikovaných prípadov',
        percentage_of_qualified_cases: 'Percento kvalifikovaných prípadov',
        number_of_unqualified_cases: 'Počet nekvalifikovaných prípadov',
        percentage_of_unqualified_cases: 'Percento nekvalifikovaných prípadov',
    },
    // 斯洛文尼亚
    slSI: {
        fill_in_at_least_one_query_condition: 'Vnesite vsaj en pogoj za poizvedbo',
        reporting_organization_name: 'Ime poročajoče organizacije',
        full_query: 'Polna poizvedba',
        query_time: 'Čas poizvedbe',
        organization_code: 'Koda organizacije',
        organization_name: 'Ime organizacije',
        country: 'Država',
        number_of_cases: 'Skupno število primerov',
        number_of_qualified_cases: 'Število ustrezajočih primerov',
        percentage_of_qualified_cases: 'Odstotek ustrezajočih primerov',
        number_of_unqualified_cases: 'Število neustrezajočih primerov',
        percentage_of_unqualified_cases: 'Odstotek neustrezajočih primerov',
    },
    // 泰语
    thTH: {
        fill_in_at_least_one_query_condition: 'กรุณากรอกเงื่อนไขการค้นหาอย่างน้อยหนึ่งรายการ',
        reporting_organization_name: 'ชื่อองค์กรที่รายงาน',
        full_query: 'สอบถามข้อมูลทั้งหมด',
        query_time: 'เวลาการสอบถาม',
        organization_code: 'รหัสองค์กร',
        organization_name: 'ชื่อองค์กร',
        country: 'ประเทศ',
        number_of_cases: 'จำนวนกรณีทั้งหมด',
        number_of_qualified_cases: 'จำนวนกรณีที่ผ่านเกณฑ์',
        percentage_of_qualified_cases: 'เปอร์เซ็นต์ของกรณีที่ผ่านเกณฑ์',
        number_of_unqualified_cases: 'จำนวนกรณีที่ไม่ผ่านเกณฑ์',
        percentage_of_unqualified_cases: 'เปอร์เซ็นต์ของกรณีที่ไม่ผ่านเกณฑ์',
    },
    // 乌克兰语
    ukUA: {
        fill_in_at_least_one_query_condition: 'Будь ласка, введіть принаймні одну умову пошуку',
        reporting_organization_name: 'Назва організації, що повідомляє',
        full_query: 'Повний запит',
        query_time: 'Час запиту',
        organization_code: 'Код організації',
        organization_name: 'Назва організації',
        country: 'Країна',
        number_of_cases: 'Загальна кількість випадків',
        number_of_qualified_cases: 'Кількість відповідних випадків',
        percentage_of_qualified_cases: 'Відсоток відповідних випадків',
        number_of_unqualified_cases: 'Кількість невідповідних випадків',
        percentage_of_unqualified_cases: 'Відсоток невідповідних випадків',
    },
    // 希腊语
    elGR: {
        fill_in_at_least_one_query_condition: 'Συμπληρώστε τουλάχιστον ένα κριτήριο αναζήτησης',
        reporting_organization_name: 'Όνομα του οργανισμού που υπέβαλε την αναφορά',
        full_query: 'Πλήρης ερώτημα',
        query_time: 'Χρόνος ερωτήματος',
        organization_code: 'Κωδικός οργανισμού',
        organization_name: 'Όνομα οργανισμού',
        country: 'Χώρα',
        number_of_cases: 'Συνολικός αριθμός περιστατικών',
        number_of_qualified_cases: 'Αριθμός επαρκών περιστατικών',
        percentage_of_qualified_cases: 'Ποσοστό επαρκών περιστατικών',
        number_of_unqualified_cases: 'Αριθμός ανεπαρκών περιστατικών',
        percentage_of_unqualified_cases: 'Ποσοστό ανεπαρκών περιστατικών',
    },
    // 爱沙尼亚
    etEE: {
        fill_in_at_least_one_query_condition: 'Sisestage vähemalt üks otsingu tingimus',
        reporting_organization_name: 'Teavitava organisatsiooni nimi',
        full_query: 'Täielik päring',
        query_time: 'Päringu aeg',
        organization_code: 'Organisatsiooni kood',
        organization_name: 'Organisatsiooni nimi',
        country: 'Riik',
        number_of_cases: 'Juhtumite koguarv',
        number_of_qualified_cases: 'Kvalifitseeritud juhtumite arv',
        percentage_of_qualified_cases: 'Kvalifitseeritud juhtumite protsent',
        number_of_unqualified_cases: 'Mittekvalifitseeritud juhtumite arv',
        percentage_of_unqualified_cases: 'Mittekvalifitseeritud juhtumite protsent',
    },
    // 哈萨克语
    kkKZ: {
        fill_in_at_least_one_query_condition: 'Кем дегенде бір сұрау шартын енгізіңіз',
        reporting_organization_name: 'Есеп беретін ұйымның атауы',
        full_query: 'Толық сұрау',
        query_time: 'Сұрау уақыты',
        organization_code: 'Ұйым коды',
        organization_name: 'Ұйым атауы',
        country: 'Ел',
        number_of_cases: 'Жағдайлардың жалпы саны',
        number_of_qualified_cases: 'Сәйкес келетін жағдайлар саны',
        percentage_of_qualified_cases: 'Сәйкес келетін жағдайлар пайызы',
        number_of_unqualified_cases: 'Сәйкес келмейтін жағдайлар саны',
        percentage_of_unqualified_cases: 'Сәйкес келмейтін жағдайлар пайызы',
    },
    // 希伯来语
    heIL: {
        fill_in_at_least_one_query_condition: 'יש למלא לפחות תנאי חיפוש אחד',
        reporting_organization_name: 'שם הארגון המדווח',
        full_query: 'שאילתה מלאה',
        query_time: 'זמן השאילתה',
        organization_code: 'קוד ארגון',
        organization_name: 'שם הארגון',
        country: 'מדינה',
        number_of_cases: 'סך כל המקרים',
        number_of_qualified_cases: 'כמות מקרים תקינים',
        percentage_of_qualified_cases: 'אחוז מקרים תקינים',
        number_of_unqualified_cases: 'כמות מקרים לא תקינים',
        percentage_of_unqualified_cases: 'אחוז מקרים לא תקינים',
    },
};
